import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import { t } from 'utils/translates';

import { selectItemById } from 'mt-react-common/common/reducers/objectCollection/reducer';
import PopUpLink from '../../../../Common/GlobalPopUps/PopUpLink';

const tasksGeoTargetAccessesCollectionRN =
  'tasksModule.collections.tasksGeoTargetAccessesCollection';

// eslint-disable-next-line react/prefer-stateless-function
class TaskGeoTargetState extends Component {
  render() {
    let result = null;
    if (this.props.checkAccessMessage) {
      if (this.props.checkAccessMessage.success) {
        result = <span className="text-success">{t('Разрешено')}</span>;
      } else {
        result = <span className="text-danger">{t('Запрещено')}</span>;
      }
    } else if (this.props.has_geo_target) {
      result = (
        <PopUpLink
          hashName="checkGeoTarget"
          hashParams={{ id: this.props.task_id }}
        >
          {t('<span class="text-success">Есть</span>, узнать')}
        </PopUpLink>
      );
    } else {
      result = <span>{t('Нет')}</span>;
    }
    return <React.Fragment>{result}</React.Fragment>;
  }
}

TaskGeoTargetState.defaultProps = {
  checkAccessMessage: null
};

TaskGeoTargetState.propTypes = {
  task_id: PropTypes.number.isRequired,
  has_geo_target: PropTypes.bool.isRequired,

  // CONNECT
  checkAccessMessage: PropTypes.shape({
    message: PropTypes.string.isRequired,
    success: PropTypes.bool.isRequired
  })
};

const mapStateToProps = (state, props) => ({
  checkAccessMessage: selectItemById(
    state,
    tasksGeoTargetAccessesCollectionRN,
    props.task_id
  )
});

export default connect(mapStateToProps)(TaskGeoTargetState);



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/CheckGeotargetAccess/TaskGeoTargetStateNew/index.js